<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-yellow-50 p-3 border-1 border-yellow-100 border-round-lg">
            <i class="pi pi-clock text-yellow-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- Main Summary Card -->
         <div class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
               <div class="bg-blue-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-calendar text-blue-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS.PREVIEW.WAIT_DAYS_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-blue-800">
                     {{ waitDays() ?? 0 }}
                     {{
                        (waitDays() ?? 0) === 1
                           ? ('DATA.COMMON.TIME.DAY' | translate)
                           : ('DATA.COMMON.TIME.DAYS' | translate)
                     }}
                  </span>
               </div>
            </div>
         </div>

         <!-- Time of Day Card -->
         <div
            *ngIf="!customizeTimeRange()"
            class="surface-card p-4 border-1 border-round-xl border-teal-100 flex flex-column gap-3"
         >
            <div class="flex align-items-center gap-3">
               <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-sun text-teal-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS.PREVIEW.TIME_OF_DAY_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-teal-800">
                     {{
                        partDay() === 'MORNING'
                           ? ('DATA.COMMON.TIME_OF_WEEK.MORNING' | translate)
                           : partDay() === 'EVENING'
                             ? ('DATA.COMMON.TIME_OF_WEEK.EVENING' | translate)
                             : partDay() === 'FULL_DAY'
                               ? ('DATA.COMMON.TIME_OF_WEEK.FULL_DAY' | translate)
                               : '-'
                     }}
                  </span>
               </div>
            </div>
         </div>

         <!-- Custom Time Range Card (if enabled) -->
         <div
            *ngIf="customizeTimeRange() && formattedTimeRange()"
            class="surface-card p-4 border-1 border-round-xl border-purple-100 flex flex-column gap-3"
         >
            <div class="flex align-items-center gap-3">
               <div class="bg-purple-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-hourglass text-purple-700 text-lg"></i>
               </div>
               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.WAIT_DAYS.PREVIEW.CUSTOM_TIME_RANGE_LABEL' | translate
                  }}</span>
                  <span class="text-xl font-semibold text-purple-800">
                     {{ formattedTimeRange() }}
                  </span>
               </div>
            </div>
         </div>

         <!-- Summary Message -->
         <p-messages severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-info-circle p-1"></span>
                  <span [innerHTML]="getSummaryMessage()"></span>
               </div>
            </ng-template>
         </p-messages>

         <p-divider *ngIf="!customizeTimeRange()" class="w-full"></p-divider>

         <!-- Regional Config Info -->
         <app-regional-config-info
            *ngIf="!customizeTimeRange()"
            [collectorIds]="campaignSelected()?.collectorIds || []"
            [campaignType]="campaignSelected()?.type"
         >
         </app-regional-config-info>

         <!-- Error Messages -->
         <div *ngIf="errors().length" class="flex flex-column gap-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- Wait Days Input -->
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.WAIT_DAYS_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.WAIT_DAYS_HELP' | translate
               }}</span>
            </div>

            <p-inputNumber
               [ngModel]="waitDays()"
               (ngModelChange)="onWaitDaysChange($event)"
               [min]="0"
               [max]="365"
               [useGrouping]="false"
               [showButtons]="true"
               buttonLayout="horizontal"
               class="w-full"
               styleClass="w-full"
               [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.WAIT_DAYS_PLACEHOLDER' | translate"
            ></p-inputNumber>
         </div>

         <p-divider></p-divider>

         <!-- Custom Time Range Checkbox -->
         <div class="flex flex-column gap-3">
            <div class="flex align-items-center gap-2">
               <p-checkbox
                  [ngModel]="customizeTimeRange()"
                  (ngModelChange)="onCustomizeTimeRangeChange($event)"
                  [binary]="true"
               ></p-checkbox>
               <label class="font-semibold text-900 cursor-pointer">
                  {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.CUSTOMIZE_TIME_RANGE_LABEL' | translate }}
               </label>
            </div>
            <span class="text-sm text-500">{{
               'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.CUSTOMIZE_TIME_RANGE_HELP' | translate
            }}</span>
         </div>

         <p-divider></p-divider>

         <!-- Custom Time Range Inputs (if enabled) -->
         <div *ngIf="customizeTimeRange()" class="flex flex-column gap-3 bg-bluegray-50">
            <div class="flex flex-row gap-2 align-items-center">
               <i class="text-blue-800 pi pi-clock"></i>
               <span class="font-semibold text-900">Personalización de franja horaria</span>
            </div>
            <div class="flex flex-row gap-3 ml-2">
               <div class="flex flex-column gap-1">
                  <label class="text-sm text-500">Desde</label>
                  <p-calendar
                     [ngModel]="interval()?.start"
                     (ngModelChange)="onTimeRangeChange('start', $event)"
                     [timeOnly]="true"
                     showIcon="true"
                     [showIcon]="true"
                     hourFormat="24"
                     [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.TIME_PLACEHOLDER' | translate"
                  ></p-calendar>
               </div>

               <div class="flex flex-column gap-1">
                  <label class="text-sm text-500">Hasta</label>
                  <p-calendar
                     [ngModel]="interval()?.finish"
                     (ngModelChange)="onTimeRangeChange('finish', $event)"
                     [timeOnly]="true"
                     hourFormat="24"
                     [showIcon]="true"
                     showIcon="true"
                     [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.TIME_PLACEHOLDER' | translate"
                  ></p-calendar>
               </div>
            </div>

            <!-- Time Range Errors -->
            <div
               *ngIf="rangeErrors().invalidOrder"
               class="p-2 bg-red-50 border-1 border-red-200 border-round-lg text-red-700 text-sm"
            >
               <i class="pi pi-exclamation-circle mr-2"></i>
               {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.INVALID_TIME_ORDER' | translate }}
            </div>
         </div>

         <!-- Part of Day Dropdown -->
         <div *ngIf="!customizeTimeRange()" class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.PART_DAY_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.PART_DAY_HELP' | translate
               }}</span>
            </div>

            <p-dropdown
               [options]="partDayOptions()"
               [ngModel]="partDay()"
               (ngModelChange)="onPartDayChange($event)"
               optionLabel="label"
               optionValue="value"
               styleClass="w-full"
               class="w-full"
               [placeholder]="'DATA.MODULES.INSPECTORS.WAIT_DAYS.CONFIG.PART_DAY_PLACEHOLDER' | translate"
            ></p-dropdown>
         </div>

         <p-divider class="w-full" *ngIf="!customizeTimeRange()"></p-divider>

         <!-- Regional Config Info -->
         <app-regional-config-info
            *ngIf="!customizeTimeRange()"
            [collectorIds]="campaignSelected()?.collectorIds || []"
            [campaignType]="campaignSelected()?.type"
         >
         </app-regional-config-info>

         <!-- Error Messages -->
         <div *ngIf="errors().length" class="flex flex-column gap-2">
            <p-messages severity="error" [closable]="false">
               <ng-template pTemplate>
                  <div class="flex flex-column gap-2 w-full">
                     <div *ngFor="let error of errors()" class="text-sm">
                        {{ error.errorMessage }}
                     </div>
                  </div>
               </ng-template>
            </p-messages>
         </div>
      </div>
   </div>
</div>
